export const PZH_CONTRACT_CANCELLATION_PERIOD = 17;

export const PZH_CONTRACT_FEE_TYPE_FULL = 'full_contract';
export const PZH_CONTRACT_FEE_TYPE_HALF = 'half_contract';
